module.exports = __webpack_public_path__ + "static/media/rupay.7cd9d447.png";